import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Button,
  Tabs,
  Tab,
  Grid,
  OutlinedInput,
  Snackbar,
  Alert,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  CircularProgress,
  Paper,
  Pagination,
  PaginationItem,
  Tooltip,
  IconButton
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

//components
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { LoadingButton, TabContext, TabPanel } from '@mui/lab';
import ContactList from 'src/components/PrivateNetworkComponents/ContactList';
import GroupList from 'src/components/PrivateNetworkComponents/GroupList';
import { api } from 'src/Api';
import moment from 'moment';
import Empty_Truck from '../../asset/open-door.png';

export default function PrivateNetwork() {
  const navigate = useNavigate();
  const location = useLocation();
  const { company_id } = location.state || {};
  const userData = JSON.parse(localStorage.getItem('user'));

  const [selectedTab, setSelectedTab] = useState(0); // State to handle the active tab
  const [selected, setSelected] = useState([]);

  const [pagesCountGroup, setpagesCountGroup] = useState(1);
  const [pageGroup, setPageGroup] = useState(1);
  const [loadingGroup, setloadingGroup] = useState(false);
  const [showGroupInput, setShowGroupInput] = useState(false);
  const [groupName, setGroupName] = useState('');

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [contactListData, setContactListData] = useState([]);

  const [editSelectedData, setEditSelectedData] = useState({});
  const [selectedId, setSelectedId] = useState('');
  const [selectedIdGroup, setSelectedIdGroup] = useState('');

  const [groupListData, setGroupListData] = useState([]);

  const [loading, setloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isDeleteLoadingGroup, setIsDeleteLoadingGroup] = useState(false);

  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');

  useEffect(() => {
    if (selectedIdGroup) {
      handleDeleteGroup(selectedIdGroup);
    }
  }, [selectedIdGroup]);

  useEffect(() => {
    if (selectedId) {
      handleDeleteContact(selectedId);
    }
  }, [selectedId]);

  useEffect(() => {
    if (selectedTab == 0) {
      getContactList(page);
    }
  }, [page, selectedTab]);

  useEffect(() => {
    if (search.length == 0) {
      contactListData.length = 0;
      getContactList(page);
    }
  }, [search]);

  //group
  useEffect(() => {
    if (selectedTab == 1) {
      getGroupList(pageGroup);
    }
  }, [pageGroup, selectedTab]);

  function getContactList(page) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    company_id && queryParams.append('user_id', company_id);

    fetch(`${api.get_contacts}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setContactListData(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setContactListData([]);
          setpagesCount(0);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      })
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  function getGroupList(page) {
    setloadingGroup(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    company_id && queryParams.append('user_id', company_id);

    fetch(`${api.get_groups}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setGroupListData(result.data);
          result?.count ? setpagesCountGroup(Math.ceil(result?.count / 10)) : setpagesCountGroup(1);
          setloadingGroup(false);
        } else {
          setGroupListData([]);
          setpagesCountGroup(0);
          setloadingGroup(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingGroup(false);
      })
      .finally(() => {
        setloadingGroup(false);
      });
  }

  // close snackbarclose funtion
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const isAllSelected = selected.length === contactListData?.length;

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Switch the tab based on user selection
    setEditSelectedData({});
    setGroupName('');
    setSelected([]);
    setShowGroupInput(false);
  };

  const handlePageChange = (event, value) => {
    contactListData.length = 0;
    setPage(value);
    getContactList(value);
  };

  const handlePageChangeGroup = (event, value) => {
    groupListData.length = 0;
    setPageGroup(value);
    getGroupList(value);
  };

  //add group function
  function handleCreateGroup() {
    setIsSaveLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    // detail_id && formdatas.append('id', detail_id);
    formdatas.append('group_name', groupName);
    company_id && formdatas.append('user_id', company_id);
    if (selected && selected.length > 0) {
      const selectedIds = selected.map((item) => item.id);
      formdatas.append('contact_no_ids', selectedIds);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.add_contacts_in_new_group, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setIsSaveLoading(false);
          setShowGroupInput(false);
          setGroupName('');
          setSelected([]);
        } else {
          setIsSaveLoading(false);
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setIsSaveLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  //delete contact function
  function handleDeleteContact(id) {
    setIsDeleteLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    id && formdatas.append('id', id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.delete_contact, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          getContactList(1);
          setIsDeleteLoading(false);
          setSelectedId('');
          setTimeout(() => {
            handleSnackbarClose();
          }, 1000);
        } else {
          setIsDeleteLoading(false);
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setSelectedId('');
        }
      })
      .catch((error) => {
        setIsDeleteLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setSelectedId('');
      });
  }

  //delete group function
  function handleDeleteGroup(id) {
    setIsDeleteLoadingGroup(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    id && formdatas.append('id', id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.delete_group, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          getGroupList(1);
          setIsDeleteLoadingGroup(false);
          setSelectedIdGroup('');
          setTimeout(() => {
            handleSnackbarClose();
          }, 1000);
        } else {
          setIsDeleteLoadingGroup(false);
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setSelectedIdGroup('');
        }
      })
      .catch((error) => {
        setIsDeleteLoadingGroup(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setSelectedIdGroup('');
      });
  }

  //edit group function
  function handleEditGroup() {
    setIsSaveLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    formdatas.append('group_name', groupName);
    formdatas.append('group_id', editSelectedData?.id);
    company_id && formdatas.append('user_id', company_id);
    if (selected && selected.length > 0) {
      const selectedIds = selected.map((item) => item.id);
      formdatas.append('contact_no_ids', selectedIds);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.add_contacts_in_existing_group, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setIsSaveLoading(false);
          setShowGroupInput(false);
          setGroupName('');
          setSelected([]);
        } else {
          setIsSaveLoading(false);
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setIsSaveLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // Toggle individual row selection
  const handleSelectRow = (contact) => {
    const selectedIndex = selected.findIndex((item) => item.id === contact.id);
    if (selectedIndex > -1) {
      setSelected(selected.filter((item) => item.id !== contact.id));
    } else {
      setSelected([...selected, contact]);
    }
  };

  // Toggle select all rows
  const handleSelectAll = () => {
    const nonExpiredShipments = contactListData.filter(
      (e) => e?.status?.toLowerCase() !== 'expired'
    );
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected(nonExpiredShipments);
    }
  };

  const getSelectEditData = (id) => {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('id', id);

    fetch(`${api.get_group_by_id}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setEditSelectedData(result.data);
          setGroupName(result?.data?.name);
          setSelected(...selected, result?.data?.contact_list);
          setSelectedTab(0);
          setShowGroupInput(true);
        } else {
          setEditSelectedData({});
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <Page title={`Private Network | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={company_id ? 'flex-start' : 'space-between'}
          mb={0}
        >
          {company_id && (
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(209,209,209,0.3)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
            </IconButton>
          )}
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            Private Network
          </Typography>
          
          {selectedTab === 1 ? (
            <>
              {groupListData.length !== 0 && userData?.role?.id !== 6 && (
                <Button
                  variant="contained"
                  // component={RouterLink}
                  startIcon={<Iconify icon="material-symbols:group-add" style={{ fontSize: 19 }} />}
                  sx={{
                    alignSelf: 'center',
                    fontSize: 11,
                    marginTop: 2,
                    textTransform: 'none',
                    marginBottom: 3
                  }}
                  onClick={() => {
                    setSelectedTab(0);
                    setShowGroupInput(true);
                  }}
                >
                  Create a Groups
                </Button>
              )}
            </>
          ) : (
            <>
              {userData?.role?.id !== 6 && (
                <Button
                  variant="contained"
                  component={RouterLink}
                  to={'/dashboard/private_network/form'}
                  startIcon={<Iconify icon="ic:round-plus" style={{ fontSize: 19 }} />}
                  sx={{ alignSelf: 'end', fontSize: 11 }}
                >
                  Add Contact
                </Button>
              )}
            </>
          )}
        </Stack>

        {/* Wrap Tabs and TabPanel in TabContext */}
        <TabContext value={selectedTab.toString()}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab sx={{ fontSize: '12px' }} label={'CONTACTS'} />
            <Tab
              // disabled={
              //   userData?.role?.id !== 6 ? contactListData.length == 0 : groupListData.length == 0
              // }
              sx={{ fontSize: '12px' }}
              label={'GROUPS'}
            />
          </Tabs>

          {selectedTab == 0 && (
            <Box
              style={{
                flexDirection: 'column',
                display: 'flex',
                flex: 1,
                marginTop: 10
              }}
              className="top_column"
            >
              <Box
                style={{
                  flexDirection: 'row',
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  flexWrap: 'wrap' // Enable wrapping for smaller screens
                }}
              >
                <Searchbar
                  style={{ width: '100%', height: 40, fontSize: 12 }}
                  width={showGroupInput || selectedTab == 1 || company_id ? '92%' : '71%'}
                  fullWidth
                  setFunction={(val) => {
                    setsearch(val);
                  }}
                  className="width_full_property"
                  placeholder={'Search Contacts'}
                  onEnter={() => {
                    setsearchLoading(true);
                    contactListData.length = 0;
                    getContactList();
                  }}
                />
                <LoadingButton
                  style={{
                    width: '6%',
                    marginLeft: '1.5%',
                    minWidth: '50px', // Ensure button has a minimum width
                    height: 40
                  }}
                  variant="contained"
                  className="width_full_status"
                  loading={searchLoading}
                  onClick={() => {
                    setsearchLoading(true);
                    setPage(1);
                    getContactList(1);
                  }}
                >
                  <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
                </LoadingButton>

                {/* Button to Create Group */}
                {!showGroupInput && selectedTab == 0 && !company_id && (
                  <>
                    {userData?.role?.id !== 6 && (
                      <Button
                        disabled={contactListData.length == 0}
                        variant="contained"
                        startIcon={
                          <Iconify icon="material-symbols:group-add" style={{ fontSize: 19 }} />
                        }
                        sx={{
                          alignSelf: 'end',
                          fontSize: 11,
                          marginLeft: 1.5,
                          width: '20%', // Relative width
                          minWidth: '100px', // Minimum width to make responsive
                          height: 40,
                          textTransform: 'none'
                        }}
                        onClick={() => {
                          setShowGroupInput(true);
                        }}
                      >
                        Create a Group
                      </Button>
                    )}
                  </>
                )}
              </Box>

              {/* Group Name Input Section */}
              {showGroupInput && selectedTab === 0 && (
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  mb={1}
                  marginTop={1}
                >
                  {/* Input Field */}
                  <Grid item xs={12} sm={10} lg={10}>
                    <OutlinedInput
                      className="width_full"
                      disableUnderline
                      variant="contained"
                      fullWidth
                      sx={{
                        height: 40,
                        fontSize: 12,
                        padding: 0,
                        margin: 0,
                        marginBottom: { xs: 1, sm: 0 }
                      }}
                      placeholder="Group Name"
                      onChange={(e) => setGroupName(e.target.value)}
                      value={groupName}
                    />
                  </Grid>

                  {/* Buttons */}
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    lg={2}
                    display="flex"
                    justifyContent={{ xs: 'flex-end', sm: 'flex-end' }}
                    gap={1}
                  >
                    <LoadingButton
                      loading={isSaveLoading}
                      variant="contained"
                      startIcon={
                        <Iconify icon="ic:round-plus" style={{ fontSize: 19, marginLeft: 14 }} />
                      }
                      sx={{
                        fontSize: 11,
                        height: 40,
                        paddingRight: 4
                      }}
                      onClick={editSelectedData?.id ? handleEditGroup : handleCreateGroup}
                      disabled={!groupName}
                    >
                      {editSelectedData?.id ? 'Update' : 'Create'}
                    </LoadingButton>

                    <Button
                      variant="contained"
                      sx={{
                        fontSize: 11,
                        height: 40
                      }}
                      onClick={() => {
                        setShowGroupInput(false);
                        setGroupName('');
                        setSelected([]);
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Box>
          )}

          <TabPanel value="0" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <>
              <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {!loading && contactListData.length !== 0 && showGroupInput && (
                        <TableCell padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={isAllSelected}
                            indeterminate={
                              selected.length > 0 && selected.length < contactListData.length
                            }
                            onChange={handleSelectAll}
                          />
                        </TableCell>
                      )}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>NAME</TableCell>{' '}
                      {/* Reduced font size */}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>EMAIL</TableCell>{' '}
                      {/* Reduced font size */}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>
                        CONTACT #
                      </TableCell>{' '}
                      {/* Reduced font size */}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>MC #</TableCell>{' '}
                      {/* Reduced font size */}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>FF #</TableCell>{' '}
                      {/* Reduced font size */}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>
                        INTRASTATE #
                      </TableCell>{' '}
                      {/* Reduced font size */}
                      <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>
                        AUTHORITY
                      </TableCell>{' '}
                      {/* Reduced font size */}
                      {!company_id && (
                        <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>ACTIONS</TableCell>
                      )}
                      {/* Reduced font size */}
                    </TableRow>
                  </TableHead>

                  {!loading && (
                    <TableBody>
                      {contactListData?.map((row, index) => (
                        <TableRow key={index}>
                          {showGroupInput && (
                            <TableCell padding="checkbox">
                              <Checkbox
                                size="small"
                                // checked={selected.includes(row)}
                                checked={selected.some((selectedRow) => selectedRow.id === row.id)}
                                onChange={() => handleSelectRow(row)}
                              />
                            </TableCell>
                          )}
                          <TableCell sx={{ fontSize: '12px' }}>{row.name}</TableCell>
                          <TableCell sx={{ fontSize: '12px' }}>{row.email}</TableCell>
                          <TableCell sx={{ fontSize: '12px', width: 120 }}>{row.contact}</TableCell>
                          <TableCell sx={{ fontSize: '12px' }}>{row.mc}</TableCell>
                          <TableCell sx={{ fontSize: '12px' }}>{row.ff}</TableCell>
                          <TableCell sx={{ fontSize: '12px' }}>{row.intrastate}</TableCell>
                          <TableCell sx={{ fontSize: '12px' }}>{row.canadian}</TableCell>
                          {!company_id && (
                            <TableCell sx={{ fontSize: '12px', width: 110, display: 'flex' }}>
                              <Tooltip title="Edit">
                                <LoadingButton
                                  size="small"
                                  variant="contained"
                                  component={RouterLink}
                                  to="/dashboard/private_network/form"
                                  state={{ id: row.id }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30,
                                    height: 30,
                                    minWidth: 30,
                                    padding: 0,
                                    lineHeight: 1,
                                    alignSelf: 'center',
                                    marginRight: 5
                                  }}
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                                    icon="bxs:edit-alt"
                                  />
                                </LoadingButton>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <LoadingButton
                                  size="small"
                                  variant="contained"
                                  onClick={() => setSelectedId(row.id)}
                                  disabled={isDeleteLoading && selectedId == row.id}
                                  loading={isDeleteLoading && selectedId == row.id}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30,
                                    height: 30,
                                    minWidth: 30,
                                    padding: 0,
                                    lineHeight: 1,
                                    alignSelf: 'center'
                                    // backgroundColor: 'red'
                                  }}
                                  to="#"
                                >
                                  {!isDeleteLoading || selectedId !== row.id ? (
                                    <Iconify
                                      style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                                      icon="ic:baseline-delete"
                                    />
                                  ) : null}
                                </LoadingButton>
                              </Tooltip>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  )}

                  {/* loader */}
                  {loading && !searchLoading && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}

                  {/* empty list */}
                  {contactListData?.length == 0 && !loading && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={10} sx={{ py: 0 }}>
                          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            height="60vh"
                          >
                            <img
                              src={Empty_Truck}
                              alt="No Contacts"
                              style={{ width: '150px', marginBottom: '20px', marginRight: 40 }}
                            />
                            <Typography variant="h5" gutterBottom>
                              You haven't added any contact yet!
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>

              {/* Pagination */}
              {!loading && pagesCount > 1 && contactListData.length !== 0 && (
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginTop: 20,
                    alignItems: 'center',
                    marginBottom: 20
                  }}
                >
                  <Pagination
                    color="primary"
                    shape="rounded"
                    page={page}
                    size="small"
                    count={pagesCount}
                    onChange={handlePageChange}
                    renderItem={(item) => <PaginationItem {...item} />}
                  />
                </Box>
              )}
            </>
          </TabPanel>

          <TabPanel value="1" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <Grid alignItems="center" display={'flex'} justifyContent={'space-between'}>
              {groupListData.length == 0 && !loadingGroup ? (
                <Container
                  maxWidth="md"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '10px',
                    width: '50%'
                  }}
                >
                  <Box
                    mb={2}
                    sx={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ color: '#5D606E', textAlign: 'center', lineHeight: 1.1 }}
                    >
                      Create groups to organize your contacts and post to them.
                    </Typography>
                  </Box>

                  <Box
                    mb={3}
                    sx={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}
                  >
                    <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#5D606E' }}>
                      How it works...
                    </Typography>
                    <Typography style={{ fontSize: 12, color: '#5D606E' }}>
                      Groups allow you to organize your contacts and post to specific people.
                    </Typography>
                  </Box>

                  <Grid
                    container
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                      <Typography
                        style={{
                          backgroundColor: '#010f58',
                          height: 20,
                          width: 20,
                          borderRadius: 100,
                          textAlign: 'center',
                          fontSize: 12,
                          color: 'white',
                          paddingTop: 1,
                          marginRight: 10
                        }}
                      >
                        1
                      </Typography>
                      <Typography style={{ fontSize: 12, color: '#5D606E' }}>
                        Assign groups to your contacts.
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography
                        style={{
                          backgroundColor: '#010f58',
                          height: 20,
                          width: 30,
                          borderRadius: 100,
                          textAlign: 'center',
                          fontSize: 12,
                          color: 'white',
                          paddingTop: 1.5,
                          marginRight: 10
                        }}
                      >
                        2
                      </Typography>
                      <Typography style={{ fontSize: 12, color: '#5D606E' }}>
                        Post to your Private Network and select your group. Only those contacts will
                        see that load and rate.
                      </Typography>
                    </Box>
                  </Grid>

                  {userData?.role?.id !== 6 && (
                    <Button
                      variant="contained"
                      component={RouterLink}
                      startIcon={
                        <Iconify icon="material-symbols:group-add" style={{ fontSize: 19 }} />
                      }
                      sx={{
                        alignSelf: 'center',
                        fontSize: 11,
                        marginTop: 2,
                        textTransform: 'none',
                        marginBottom: 3
                      }}
                      onClick={() => {
                        setSelectedTab(0);
                        setShowGroupInput(true);
                      }}
                    >
                      Create a Group
                    </Button>
                  )}
                </Container>
              ) : (
                <>
                  <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>NAME</TableCell>{' '}
                          {/* Reduced font size */}
                          <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>
                            GROUP MEMBERS
                          </TableCell>{' '}
                          {/* Reduced font size */}
                          <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>
                            LAST MODIFIED
                          </TableCell>{' '}
                          {/* Reduced font size */}
                          {!company_id && (
                            <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>
                              ACTION
                            </TableCell>
                          )}{' '}
                          {/* Reduced font size */}
                        </TableRow>
                      </TableHead>

                      {!loadingGroup && (
                        <TableBody>
                          {groupListData?.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell sx={{ fontSize: '12px' }}>{row.name}</TableCell>
                              <TableCell sx={{ fontSize: '12px' }}>{row.count}</TableCell>
                              <TableCell sx={{ fontSize: '12px' }}>
                                {moment(row.updated_at).format('MM/DD/YYYY - hh:mm A')}
                              </TableCell>
                              {!company_id && (
                                <TableCell sx={{ fontSize: '12px', width: 110, display: 'flex' }}>
                                  <Tooltip title="Edit">
                                    <LoadingButton
                                      size="small"
                                      variant="contained"
                                      // component={RouterLink}
                                      onClick={() => getSelectEditData(row?.id)}
                                      state={{ id: row.id }}
                                      style={{
                                        justifyContent: 'center',
                                        width: 30,
                                        height: 30,
                                        minWidth: 30,
                                        padding: 0,
                                        lineHeight: 1,
                                        alignSelf: 'center',
                                        marginRight: 5
                                      }}
                                    >
                                      <Iconify
                                        style={{
                                          cursor: 'pointer',
                                          fontSize: 17,
                                          color: '#ffffff'
                                        }}
                                        icon="bxs:edit-alt"
                                      />
                                    </LoadingButton>
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <LoadingButton
                                      size="small"
                                      variant="contained"
                                      onClick={() => setSelectedIdGroup(row.id)}
                                      disabled={isDeleteLoadingGroup && selectedIdGroup == row.id}
                                      loading={isDeleteLoadingGroup && selectedIdGroup == row.id}
                                      style={{
                                        justifyContent: 'center',
                                        width: 30,
                                        height: 30,
                                        minWidth: 30,
                                        padding: 0,
                                        lineHeight: 1,
                                        alignSelf: 'center'
                                        // backgroundColor: 'red'
                                      }}
                                      to="#"
                                    >
                                      {!isDeleteLoadingGroup || selectedIdGroup !== row.id ? (
                                        <Iconify
                                          style={{
                                            cursor: 'pointer',
                                            fontSize: 17,
                                            color: '#ffffff'
                                          }}
                                          icon="ic:baseline-delete"
                                        />
                                      ) : null}
                                    </LoadingButton>
                                  </Tooltip>
                                </TableCell>
                              )}
                              {/* <TableCell sx={{ fontSize: '12px' }}>
                                <Button
                                  variant="contained"
                                  component={RouterLink}
                                  onClick={() => {
                                    getSelectEditData(row?.id);
                                  }}
                                  startIcon={
                                    <Iconify icon="akar-icons:edit" style={{ fontSize: 15 }} />
                                  }
                                  sx={{ alignSelf: 'end', fontSize: 11 }}
                                >
                                  Edit
                                </Button>
                              </TableCell> */}
                            </TableRow>
                          ))}
                        </TableBody>
                      )}

                      {/* loader */}
                      {loadingGroup && (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                              <CircularProgress />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>

                  {/* Pagination */}
                  {!loadingGroup && pagesCountGroup > 1 && groupListData.length !== 0 && (
                    <Box
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        marginTop: 20,
                        alignItems: 'center',
                        marginBottom: 20
                      }}
                    >
                      <Pagination
                        color="primary"
                        shape="rounded"
                        page={pageGroup}
                        size="small"
                        count={pagesCountGroup}
                        onChange={handlePageChangeGroup}
                        renderItem={(item) => <PaginationItem {...item} />}
                      />
                    </Box>
                  )}
                </>
              )}
            </Grid>
          </TabPanel>
        </TabContext>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
